import styled from 'styled-components';
import { colors } from "../../../../styles/colors";

export const PriceModal = styled.div`
  position: fixed;
  z-index: 999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .modalContent{
    border-radius: 10px !important;
    background: #F2F2F2;
    width: 1286px;
    height: 775px;
  }
  `;

export const ModalContainer = styled.div`
  padding: 20px 30px;
  width: 100%;
  height: 100%;
  p{
    width: auto;
    font-size: 16px;
  }
`;

export const HeaderContent = styled.div`
  align-items: center;
  flex-grow: 1;

  .modalTitle{
    justify-content: space-between !important;
    display: flex;
    align-items: center;
    font-size: 16px;
  }

  .uppercase{
    text-transform: uppercase;
  }

  .customerInfo{
    width: 100%;
    font-size: 16px;
    border-bottom: 1px solid #BEBEBE;
    padding: 20px 0;
  }
`;

export const ItemInfo = styled.div`
  display: grid;
  grid-template-columns: 60px 100px 300px 80px 65px 150px 110px 121px 121px 121px;
  padding: 20px 0;

  p{
    font-size: 12px !important;
  }

  .description{
    width: 270px;
  }
`;

export const PrinceInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0 45px;
  label{
    font-size: 12px;
    color: #858585;
    margin-bottom: 5px;
  }

  .cdContent{
    border-right: 1px solid rgba(190, 190, 190, 1);
    width: 73%;

    .cdPrice{
      width: 95px;
    }

    p{
      font-weight: 700;
      color: ${colors.viveoDarkBlue};

      &.PriceValue{
        font-size: 12;
      }

      &.priceLabel{
        font-size: 12px !important;
      }
    }
  }

  .listMinimumPriceSliderContainer {
    padding: 2px;
  }

  .listMinimumPriceSlider {
    width: 100%;
  }

  .listMinimumPriceSlider::before,
  .listMinimumPriceSlider::after {
    background: linear-gradient(to right, rgba(242, 242, 242, 1) 0.025%,
    rgba(242, 242, 242, 0) 25%);
    content: '';
    height: 100%;
    position: absolute;
    width: 5%;
    z-index: 2;
  }

  .listMinimumPriceSlider::before {
    left: 0;
    top: 0;
  }

  .listMinimumPriceSlider::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }

  .competitorPriceRow {
    display: flex;
    flex-direction: column;
  }

  .suggestedPrice{
    margin-left: 45px;
  }

  .lastCompetitorPrice{
    margin-left: 40px;
    
    span{
      font-size: 8px;
    }
  }

  .competitorPrice{
    margin-left: 45px;
  }
`;

export const SuggestedPrice = styled.button`
  justify-content: center;
  background: #0E4C54;
  align-items: center;
  border-radius: 4px;
  display: flex;
  width: 105px;
  height: 24px;
  padding: 0 10px;
  margin-top: 4px;

  &:hover{
    cursor: pointer;
  }

  p{
    color: #FFFFFF !important;
    line-height: 12px;
    font-size: 12px !important;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;

  .historyImg{
    width: 19px;
    height: 18px;
    margin-right: 6px;
  }

  p{
    color: ${colors.viveoDarkBlue};
    font-weight: 400;
  }

  & em {
    font-weight: bold;
    font-style: normal;
  }
`;

export const HeaderText = styled.p<{ fontWeight?: string, lineHeight?: string, style?: any, contrast?: boolean; }>`
  color: ${colors.mfDarkGrey};
  font-weight: ${props => props.fontWeight ?? 400};
  line-height: ${props => props.lineHeight ?? '16px'};
  font-style: normal;


  & em {
    font-weight: bold;
    font-style: normal;
    color: ${colors.viveoDarkBlue};
  }

  font-weight: ${props => props.contrast ? 700 : ''};
  color: ${props => props.contrast ? colors.viveoDarkBlue : ''};
`;